import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0E86D4',
      // main: "#F25804",
      // main: "#E4F7FD",
      // main: "#B0C0DB",
    },
    secondary: {
      main: '#F48336',
      // main: "#0E86D4",
    },
    error: {
      main: red.A400,
    },
  },
  typography: {
    fontFamily: [
      'Segoe ui',
      'Roboto',
      'Helvetica Neue',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

export default theme;

// background: {
//   default: '#f4f4f4',
// },
